import React from 'react';
import NeighborhoodPainPost from '../components/NeighborhoodPainPost';

const BlogPostPocketPain = () => (
  <NeighborhoodPainPost
    data={{
      neighborhood: 'The Pocket',
      slug: 'back-and-neck-pain-massage-the-pocket',
      image:
        'https://images.unsplash.com/photo-1590212151175-e58edd96185b?w=1600&auto=format&fit=crop&q=80',
      driveMinutes: '15–20 minutes',
      driveNote:
        'the drive from The Pocket to 2528 I Street is a direct trip via I-5 and 15th Street',
      routes: [
        'From The Pocket / Riverside Boulevard area: ~15–18 minutes via I-5 north',
        'From Little Pocket: ~12–15 minutes via Freeport Boulevard and 21st',
        'From near Pocket Road: ~18–20 minutes via I-5',
      ],
      nearbyAreas: [
        'The Pocket, Sacramento',
        'Land Park, Sacramento',
        'South Land Park, Sacramento',
        'Greenhaven, Sacramento',
        'Midtown Sacramento',
      ],
      pageTitle:
        'Back and Neck Pain Massage in The Pocket | Ayumi Suzuki',
      hookLine:
        'Dealing with chronic back or neck pain in The Pocket and wondering where the closest certified massage therapist is?',
      dataTestId: 'pocket-pain-blog-page',
    }}
  />
);

export default BlogPostPocketPain;
